import React from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { eliminarVueloPaqueteAction, obtenerVuelosByIdPaqueteAction } from "../../../ducks/vueloDuck";
import Swal from "sweetalert2";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
  },
})

const TablaRegistro = (props) => {
  const { rows = [], idPaquete = 0, clavePaquete = '' } = props;
  console.log("🚀 ~ file: TablaRegistro.js ~ line 31 ~ TablaRegistro ~ rows", rows)
  const dispatch = useDispatch();
  const classes = useStyles();
  const onDelete = (row) =>{
    DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminarlo',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) =>{
      if (result.isConfirmed) {
        dispatch(eliminarVueloPaqueteAction({idPaquete: idPaquete, idVuelo: row?.Vuelo?.IdVuelo, ClavePaquete: clavePaquete, ClaveProveedor: row?.ClaveProveedor })).then(Response =>{
          dispatch(obtenerVuelosByIdPaqueteAction(idPaquete));
          ToastMessage.fire(
            '¡Elimminado!',
            '!El vuelo ha sido eliminado.',
            'success'
          )
        })
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        ToastMessage.fire(
          'Cancelado',
          'No se ha realizado ningun cambio',
          'info'
        )
      }
    })
  }
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Vuelo</TableCell>
            <TableCell align="center">Redondo</TableCell>
            <TableCell align="center">Aerolinea</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index+1}>
              <TableCell align="left">{`${row.Vuelo.Origen.CodigoIATA} ${row.Vuelo.Origen.Descripcion} > ${row.Vuelo.Destino.CodigoIATA} ${row.Vuelo.Destino.Descripcion}`}</TableCell>
              <TableCell align="center">{(row.Redondo) ? <CheckCircleIcon color="secondary"/> : null}</TableCell>
              <TableCell align="center">{`${row.ClaveProveedor}`}</TableCell>
              <TableCell align="center">
                <ButtonGroup
                  color="primary"
                  size="small"
                  aria-label="small outlined  button group"
                >
                  <Button onClick={() => onDelete(row)}>Eliminar</Button>
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TablaRegistro;
